"use client";

import type { PublicationModel } from "../types/models";
import { getShortSelectionSummary } from "./publicationFlow/shortSelection";
import Typography from "./Typography";

/**
 * Shared by both short pickers: committed status as a short caption under
 * the title (Posted / N of M posted / Already scheduled). Drafts and
 * failures show nothing.
 */
export default function VideoPublicationSummary({
  publications,
}: {
  publications: PublicationModel[];
}) {
  const summary = getShortSelectionSummary(publications);
  if (!summary.label) return null;
  return (
    <div
      className="w-fit max-w-full rounded outline-none focus-visible:ring-2 focus-visible:ring-ring"
      role="img"
      tabIndex={0}
      aria-label={summary.tooltip ?? summary.label}
      data-tooltip-id="global"
      data-tooltip-content={summary.tooltip ?? summary.label}
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          event.stopPropagation();
        }
      }}
    >
      <Typography
        variant="caption"
        className="!m-0 truncate text-slate-500 dark:text-foreground-secondary"
      >
        {summary.label}
      </Typography>
    </div>
  );
}
